import alert from '@/plugins/alert'
import { Course, Upload, CourseMark, CourseMarkElement, CourseMarkConfig } from '@/plugins/api'
import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    courses: {},
    courseMarkConfigs: [],
    count: 0,
    courseMarkElements: [],
    isLoadingCourseMarkConfigs: false
  },
  actions: {
    async fetchCourseMarkConfigs({ commit }, course, options) {
      try {
        commit('setCourseMarkConfigs', await CourseMarkConfig.fetch({ course }, options))
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async fetchCourses({ commit }, options) {
      try {
        commit('setCourses', await Course.fetch(options))
      } catch (e) {
        alert.error(e)
      }
    },
    async countCourses({ commit }, options) {
      try {
        commit('setCount', await Course.count(options))
      } catch (e) {
        alert.error(e)
      }
    },
    async fetchCourse({ commit }, courseId) {
      try {
        const course = await Course.fetchOne(courseId)
        commit('addCourses', course)
      } catch (e) {
        alert.error(e)
        console.error(e)
      }
    },
    async createCourse({ commit }, { data, options }) {
      try {
        commit('addCourses', await Course.create(data, options))
      } catch (e) {
        alert.error(e)
        console.error(e)
      }
    },
    async createCourseMarkConfig({ commit }, { data, options }) {
      try {
        const res = await CourseMarkConfig.create(data, options)

        commit('addCourseMarkConfigs', res)
        return res
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async updateCourseMarkConfig({ commit }, { id, data, options }) {
      try {
        commit('updateCourseMarkConfig', await CourseMarkConfig.update(id, data, options))
      } catch (e) {
        alert.error(e)
        console.error(e)
      }
    },
    async updateManyCourseMarks({ commit }, { id, data, options }) {
      try {
        commit('updateManyCourseMarks', { id, data: await CourseMark.updateMany(data, options) })
      } catch (e) {
        alert.error(e)
        console.error(e)
      }
    },
    async updateManyCourseMarkElements({ commit }, { id, data, options }) {
      try {
        commit('updateManyCourseMarkElements', {
          id,
          data: await CourseMarkElement.updateMany(data, options)
        })
      } catch (e) {
        alert.error(e)
        console.error(e)
      }
    },
    async createCourseMark({ commit }, { data, options }) {
      try {
        const createdMark = await CourseMark.create(data, options)
        commit('addCourseMarkToConfig', { data: createdMark, id: data.course_mark_config })
        return createdMark
      } catch (error) {
        alert.error(error)
      }
    },
    async createCourseMarkElement({ commit }, { data, options }) {
      try {
        const createdElement = await CourseMarkElement.create(data, options)
        commit('addCourseMarkElementToConfig', {
          data: createdElement,
          id: data.course_mark_config
        })
        return createdElement
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async updateCourseMarkElement({ commit }, { id, data, options }) {
      try {
        const res = await CourseMarkElement.update(id, data, options)
        commit('updateCourseMarkElement', res)
      } catch (error) {
        alert.error(error)
      }
    },
    async removeCourseMarkElement({ commit }, { id, courseMarkConfigId, options }) {
      try {
        const removed = await CourseMarkElement.remove(id, options)
        commit('removeCourseMarkElementFromConfig', { id, courseMarkConfigId })
        return removed
      } catch (error) {
        alert.error(error)
      }
    },
    async removeCourseMarkConfig({ commit }, { id, options }) {
      try {
        await CourseMarkConfig.remove(id, options)
        commit('removeCourseMarkConfig', id)
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async updateCourseMark({ commit }, { id, data, options }) {
      try {
        const res = await CourseMark.update(id, data, options)
        commit('updateCourseMark', res)
      } catch (error) {
        alert.error(error)
      }
    },
    async removeCourseMark({ commit }, { id, courseMarkConfigId, options }) {
      try {
        const createdMark = await CourseMark.remove(id, options)
        commit('removeCourseMarkFromConfig', { id, courseMarkConfigId })
        return createdMark
      } catch (error) {
        alert.error(error)
      }
    },
    async updateCourse({ commit, state }, { id, ...course }) {
      try {
        commit('updateCourses', await Course.update(id, course))
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async removeCourse({ commit }, id) {
      try {
        await Course.remove(id)
        commit('removeCourse', id)
        alert.success('Xóa thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    setCourse({ commit, state }, course) {
      commit('setCourse', course)
    },
    async removeCourses({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeCourse', item.id)
      }
    },
    async uploadAvatar({ commit }, { courseId, formData }) {
      try {
        let data = await Upload.upload(formData)
        commit('setAvatar', { courseId, avatar: data[0] })
        alert.success('Upload successfully!')
      } catch (e) {
        alert.error(e)
      }
    },
    async destroyAvatar({ commit }, id) {
      try {
        await Upload.destroy(id)
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setCourses(state, courses) {
      state.courses = _.keyBy(courses, i => i.id)
    },
    setCourseMarkConfigs(state, courseMarkConfigs) {
      state.courseMarkConfigs = courseMarkConfigs
    },
    setIsLoadingCourseMarkConfigs(state, val) {
      state.isLoadingCourseMarkConfigs = val
    },
    updateCourseMarkConfig(state, item) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => (i.id === item.id ? item : i))
    },
    updateCourseMark(state, item) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => {
        if (item.course_mark_config.id === i.id) {
          const { course_marks, ...o } = i
          return { ...o, course_marks: course_marks.map(j => (j.id === item.id ? item : j)) }
        }
        return i
      })
    },
    updateCourseMarkElement(state, item) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => {
        if (item.course_mark_config.id === i.id) {
          const { course_mark_elements, ...o } = i
          return {
            ...o,
            course_mark_elements: course_mark_elements.map(j => (j.id === item.id ? item : j))
          }
        }
        return i
      })
    },
    updateManyCourseMarks(state, { id, data }) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => {
        if (id === i.id) {
          const { course_marks, ...o } = i
          return { ...o, course_marks: _.uniqBy([...data, ...course_marks], i => i.id) }
        }
        return i
      })
    },
    updateManyCourseMarkElements(state, { id, data }) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => {
        if (id === i.id) {
          const { course_mark_elements, ...o } = i
          return {
            ...o,
            course_mark_elements: _.uniqBy([...data, ...course_mark_elements], i => i.id)
          }
        }
        return i
      })
    },
    addCourseMarkToConfig(state, { data, id }) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => {
        if (i.id === id) {
          const { course_marks, ...o } = i
          return { ...o, course_marks: [...course_marks, data] }
        }
        return i
      })
    },
    addCourseMarkElementToConfig(state, { data, id }) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => {
        if (i.id === id) {
          const { course_mark_elements, ...o } = i
          return { ...o, course_mark_elements: [...course_mark_elements, data] }
        }
        return i
      })
    },
    addCourses(state, ...courses) {
      state.courses = { ...state.courses, ..._.keyBy(courses, i => i.id) }
    },
    addCourseMarkConfigs(state, ...courses) {
      state.courseMarkConfigs = [...state.courseMarkConfigs, ...courses]
    },
    removeCourse(state, courseId) {
      delete state.courses[courseId]
      state.courses = { ...state.courses }
    },
    removeCourseMarkConfig(state, id) {
      state.courseMarkConfigs = state.courseMarkConfigs.filter(i => i.id !== id)
    },
    removeCourseMarkFromConfig(state, { id, courseMarkConfigId }) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => {
        if (i.id === courseMarkConfigId) {
          const { course_marks, ...o } = i
          return { ...o, course_marks: course_marks.filter(c => c.id !== id) }
        }
        return i
      })
    },
    removeCourseMarkElementFromConfig(state, { id, courseMarkConfigId }) {
      state.courseMarkConfigs = state.courseMarkConfigs.map(i => {
        if (i.id === courseMarkConfigId) {
          const { course_mark_elements, ...o } = i
          return { ...o, course_mark_elements: course_mark_elements.filter(c => c.id !== id) }
        }
        return i
      })
    },
    setAvatar(state, { courseId, avatar }) {
      _.set(state.courses, `${courseId}.avatar`, avatar)
      state.courses = { ...state.courses }
    }
  },
  getters: {
    courses: state => {
      return Object.values(state.courses)
    },
    course: state => id => {
      return state.courses[id]
    },
    count: state => {
      return state.count
    }
  }
}
